

























































































import Vue from 'vue';
import axios from 'axios';
import ReviewHeader from '@/parts/review/ReviewHeader.vue';
import PaymentForm, { CardFormResult } from '@/parts/util/PaymentForm.vue';
import PaymentDetails from '@/parts/util/PaymentDetails.vue';
import MessageModal from '@/parts/util/MessageModal.vue';
import { ErrorResponse } from '@/api/dto/Error';

import { ReviewForm, toCreateReviewRequestFromReviewForm, toUpdateReviewRequestFromReviewForm } from './ReviewForm';
import { createReview, updateReviewStatus, updateReview } from '@/api/Review';
import { UserProfile } from '@/api/dto/UserProfile';
import { createPaymentInfomation } from '@/api/UserProfile';
import { CreatePaymentInformationRequest} from '@/api/dto/UserProfile';

const toCreatePaymentInformationRequest = (result: CardFormResult): CreatePaymentInformationRequest => {
  return {
    cardToken: result.cardForm!.cardToken,
  };
}

export default Vue.extend({
  name: 'ReviewPayout',
  components: {
    ReviewHeader,
    PaymentForm,
    PaymentDetails,
    MessageModal,
  },
  data() {
    return {
      reviewData: {} as ReviewForm,
      cardSelect: false,
      cardInputFlg: true,
      // モーダル 関連
      modalOpen: false,
      reaveModal: false,
      completeModal: false,
      confirmModal: false,
      // 汎用
      allowLeave: false,
      goBack: false,
      nextPath: '',
    }
  },
  created() {
    this.cardSelect = this.loginData.registeredCreditCard;
    this.cardInputFlg = !this.loginData.registeredCreditCard;
    this.initData();
  },
  async beforeRouteLeave(to, from, next) {
    if(!this.$browserBackFlg){ // ブラウザバック以外の場合
      // ガイド.よくある質問は別タブ
      if (to.path == '/guide' || to.path == '/faq') {
        window.open(to.path, '_blank');
        return;
      }
    }
    if(!this.allowLeave){ // ページ離脱を許されていない場合
      if(!(to.name == 'ReviewDraftConfirm' || to.name == 'ReviewConfirm')){ // 確認画面を除く
        this.goBack = this.$browserBackFlg; // ブラウザバックであるか
        this.reaveModalOpen(to.path);
        next(false);
        return;
      }
    }
    this.allowLeave = false;
    next();
  },
  computed: {
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    dealId(): string {
      return this.$route.params.dealId;
    },
    isNewReview(): boolean {
      return this.$route.path == '/review/payout';
    },
  },
  methods: {
    async initData() {
      var storeReviewForm = this.$store.getters.reviewForm as ReviewForm;
      if(storeReviewForm.dealId == this.dealId && storeReviewForm.title && (!storeReviewForm.dealStatus || storeReviewForm.dealStatus  == '1')){
        this.reviewData = JSON.parse(JSON.stringify(storeReviewForm));
      } else {
        this.allowLeave = true;
        if(this.isNewReview){
          this.$router.replace({name:'ReviewDraft'});
        } else {
          this.$router.replace({name:'ReviewEdit',params:{dealId:this.dealId}});
        }
      }
    },
    // モーダル 関連
    reaveModalOpen(path: string) {
      this.modalOpen = true;
      this.reaveModal = true;
      this.nextPath = path;
    },
    completeModalOpen() {
      this.modalOpen = true;
      this.completeModal = true;
    },
    async confirmModalOpen() {
      this.modalOpen = true;
      this.confirmModal = true;
    },
    /** 確認モーダルの「OK」click ハンドラ */
    onClickOkOnConfirmModal() {
      this.confirmModal = false;
      this.modalOpen = false,
      // 決済して公開する
      this.reviewSubmit('settlement');
    },
    modalClose() {
      if(!this.completeModal){ // レビュー依頼を公開しましたの場合、閉ざさせない
        this.modalOpen = false;
        this.reaveModal = false;
      }
      this.confirmModal = false;
    },
    // 公開したページを見る
    toReview() {
      this.$router.push({name:'Review',params:{dealId:this.reviewData.dealId as string}});
    },
    // 取引管理へ
    toDealsManagement() {
      this.$router.push({name:'DealsManagement'});
    },
    // 破棄
    destroy() {
      this.modalClose();
      this.$store.dispatch('initReviewForm');
      this.allowLeave = true;
      if(this.goBack){
        this.$router.go(-1);
      } else {
        this.$router.push(this.nextPath);
      }
    },
    // ページ離脱による下書き保存 or 編集内容を保存
    saveLeave() {
      this.reviewSubmit('save');
    },
    // 汎用
    async reviewSubmit(action: string) {
      if(action == 'settlement'){
        var result = {} as CardFormResult;
        // 新しいクレジットカードを使用する場合、チェック
        if(this.cardInputFlg){
          result = await (this.$refs.paymentForm as any).validation();
          if(result.message) {
            this.$emit('errorToast', result.message);
            return;
          }
          // クレジットカードを登録
          if(result.cardForm!.cardSaveFlg) {
            await createPaymentInfomation(toCreatePaymentInformationRequest(result));
          }
        }
        try {
          if (!this.reviewData.dealId) {
            // レビュー作成API 取引ステータス:下書き
            var res = await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.reviewData.dealId = res.dealId;
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書き）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
          }
          // 決済 取引ステータス:下書き⇒受注待ち
          await updateReviewStatus(this.reviewData.dealId as string, { dealStatus: '2' });
          // 新しいクレジットカードで登録した場合、カード番号下4桁が更新されるので、ユーザー情報取得し更新
          if(this.cardInputFlg && result.cardForm!.cardSaveFlg){
            this.$store.dispatch('userUpdate');
          }
          this.$store.dispatch('initReviewForm');
          this.allowLeave = true;
          this.completeModalOpen();
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "登録に失敗しました。時間をおいて再度お試しください。");
            } else {
              if (resError.code == '3007') {
                this.allowLeave = true;
                this.$router.push({ name: "Top" });
                return;
              }
              this.allowLeave = true;
              this.$emit('errorToast', resError.message);
              this.$router.push({ name: "Top" });
            }
          }
        }
      } else if(action == 'save'){
        try {
          if (this.isNewReview) {
            // レビュー作成API 取引ステータス:下書き
            await createReview(toCreateReviewRequestFromReviewForm(this.reviewData));
            this.$emit('toast', '下書き保存しました');
          } else {
            // レビュー更新API 取引ステータス:そのまま（下書き⇒下書き）
            await updateReview(this.reviewData.dealId as string, toUpdateReviewRequestFromReviewForm(this.reviewData));
            this.$emit('toast', '編集内容を保存しました');
          }
          this.destroy();
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
})
